<template>
  <div
    class="mt-8 grid grid-cols-1 md:grid-cols-2 md:gap-5"
    v-if="fondsStore.selectedFonds !== null"
  >
    <div class="mt-2 w-full">
      Ihr envestor-Vorteil für den Fonds
      <strong class="text-orange-400">{{ fondsStore.selectedFonds.name }}</strong> bei der
      <strong class="text-orange-400">{{ fondsStore.selectedBank.name }}</strong>
      <EnvestorAdvantage></EnvestorAdvantage>
    </div>
    <div class="w-full">
      <div class="mt-5 overflow-hidden rounded-md border-2 border-green-400 bg-white p-5 md:mt-0">
        <div class="px-4 py-5 sm:p-0">
          <dl class="">
            <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-3">
              <dt class="text-sm font-medium text-gray-500">Cashback</dt>
              <dd class="mt-1 text-right text-2xl font-bold text-green-600 sm:col-span-2 sm:mt-0">
                {{ commission }}
              </dd>
            </div>
            <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-3">
              <dt class="text-sm font-medium text-gray-500">Agio Rabatt</dt>
              <dd class="mt-1 text-right text-2xl font-bold text-green-600 sm:col-span-2 sm:mt-0">
                {{ agio }}
              </dd>
            </div>
            <div class="py-2 sm:py-3">
              <button @click="newEnvestor"
                type="button"
                class="text-md float-right inline-flex w-full items-center justify-center rounded-md border border-transparent bg-green-500 px-4 py-2 font-medium text-white shadow-sm transition duration-500 ease-in-out hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-500"
              >
                Jetzt envestor werden und sparen
              </button>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFondsStore } from '@/stores/fonds'
import { computed } from 'vue'
import EnvestorAdvantage from '@/components/EnvestorAdvantage.vue'
import { moneyFormat } from '@/filters/toCurrency.filter'
const fondsStore = useFondsStore()

function newEnvestor() {
  window.location.href='https://app.envestor.de/#!/access/register'
}

const agio = computed(() =>
  moneyFormat((fondsStore.defaultInvest / 100) * (fondsStore.getCourtage()?.agio || 0))
)
const commission = computed(() =>
  moneyFormat(
    (Math.round(fondsStore.getCourtage()?.portfolioCommission || 0) / 10000) *
      fondsStore.defaultInvest
  )
)
</script>
